export const dineAroundRules = {
  noRestriction: 'No restriction',
  oneAtEach: '1 at each',
  twoAtEach: '2 at each',
  oneAtEachSatSunFreeMonday: '1 at each Sat-Sun then free flow Monday',
  oneAtEachTueThuFreeFriday: '1 at each Tue-Thu then free flow Friday',
  noMoreThanOneAtAVenue: 'No more than 1 at a venue',
};

export const dineAroundBreakfastType = 'DINE AROUND BREAKFAST';
export const dineAroundDinnerType = 'DINE AROUND DINNER';
export const dineAroundLocation = 'DINE AROUND';
